module.exports = __webpack_public_path__ + "img/21_11.f14f604d.png";